export default __webpack_public_path__ + "static/media/companies-benefits-04.3f06f63f.webp";